export const formatCpfCnpj = (value = "") => {
    const raw = `${value || ""}`.trim()
    const digits = raw.replace(/\D/g, "")
    if (digits.length <= 11) {
        return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, (m, a, b, c, d) =>
            [a, b, c, d].filter(Boolean).join(".").replace(/\.([^.]+)$/, "-$1")
        )
    }
    if (digits.length === 14) {
        return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2})/, (m, a, b, c, d) =>
            [a, b, c, d].filter(Boolean).join(".").replace(/\.([^.]+)$/, "-$1")
        )
    }
    // Retorna o valor bruto quando não bate com CPF/CNPJ numérico padrão (ex.: CH66020450137)
    return raw
}
